import React, { useEffect, useMemo } from 'react';
import { Outlet, useMatch } from 'react-router-dom';

import { useNavigateWithParams } from 'hooks/useNavigateWithParams';
import { useAuth } from 'hooks/useAuth';
import { useMemberGroupData } from 'hooks/useMemberGroupData';

import { NavMenu } from 'components/ui/NavMenu';

import Arrow from 'assets/pursuit-arrow.png';
import Dots from 'assets/pursuit-dots.png';
import Scribble from 'assets/pursuit-scribble.png';
import Plus from 'assets/pursuit-plus.png';

import { MainViewWrapper } from 'styles/shared';

export const PursuitMember = () => {
    const navigateWithParams = useNavigateWithParams();
    const { userProfile } = useAuth();
    const { group } = useMemberGroupData();

    const pursuitWithNoSubRoute = useMatch('/pursuit');
    const sessionRoute = useMatch('/pursuit/sessions/*');
    const directoryRoute = useMatch('/pursuit/directory/*');
    const insightsRoute = useMatch('/pursuit/insights/*');
    const resourcesRoute = useMatch('/pursuit/resources/*');

    useEffect(() => {
        if (pursuitWithNoSubRoute != null && userProfile != null) {
            if ((userProfile?.member_groups?.length ?? 0) > 0) {
                navigateWithParams(
                    `/pursuit/sessions${
                        group?.session_counter == null
                            ? ''
                            : `/${group?.session_counter}/description`
                    }`
                );
            } else {
                navigateWithParams('/pursuit/directory');
            }
        }
    }, [
        group?.session_counter,
        navigateWithParams,
        pursuitWithNoSubRoute,
        userProfile,
        userProfile?.member_groups?.length,
    ]);

    const menuItems = useMemo(() => {
        const tabsToReturn = [
            {
                text: 'Insights',
                link: '/pursuit/insights/group-learnings',
                imageUrl: Scribble,
                isSelected: insightsRoute != null,
            },
            {
                text: 'Directory',
                link: '/pursuit/directory',
                imageUrl: Dots,
                isSelected: directoryRoute != null,
            },
            {
                text: 'Resources',
                link: '/pursuit/resources',
                imageUrl: Plus,
                isSelected: resourcesRoute != null,
            },
        ];

        if ((userProfile?.member_groups?.length ?? 0) > 0) {
            tabsToReturn.unshift({
                text: 'Sessions',
                link: `/pursuit/sessions/${group?.session_counter}/description`,
                imageUrl: Arrow,
                isSelected: sessionRoute != null,
            });
        }

        return tabsToReturn;
    }, [
        insightsRoute,
        directoryRoute,
        resourcesRoute,
        userProfile?.member_groups?.length,
        group?.session_counter,
        sessionRoute,
    ]);

    return (
        <MainViewWrapper>
            <NavMenu menuItems={menuItems} isPursuitMenu />
            <Outlet />
        </MainViewWrapper>
    );
};
